import React from 'react';
import {
  SkeletonGroup,
  Layout,
  Cell,
  SkeletonLine as WSRSkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';

export const SkeletonLine = ({
  span,
  marginBottom,
}: {
  span?: number;
  marginBottom?: string;
}) => (
  <SkeletonGroup>
    <Layout>
      <Cell span={span}>
        <WSRSkeletonLine marginBottom={marginBottom} />
      </Cell>
    </Layout>
  </SkeletonGroup>
);

export const SkeletonContent = () => (
  <SkeletonGroup dataHook="loading-state-skeleton-group">
    <Layout gap="SP6">
      <Cell>
        <SkeletonRectangle height="30px" width="240px" />
      </Cell>
      <Cell>
        <SkeletonRectangle height="30px" width="240px" />
      </Cell>
    </Layout>
  </SkeletonGroup>
);
